import { apiPrefix, apiBasic } from './apiPrefix'
import reconcileBillApi from './reconcileBill.api'
import srmApi from './srm.api'

// 水印服务
const getMixWaterMarkImage = '/api-wm/image'
const getWaterMarkImage = '/api-wm/image/visible'
const api = {
  // 合作商对账单查询
  ...reconcileBillApi,
  // 单车供应商中心
  ...srmApi,

  // 公共
  decodeByToken: `${apiPrefix}/token/decrypt`,
  getMenuTree: `${apiPrefix}/staff/getMenuTree`,
  getAuthUrls: `${apiPrefix}/staff/getAuthUrls`,
  commonUserInfo: `${apiPrefix}/get_sso_info`,
  commonGetAuthRegions: `${apiPrefix}/getAuthRegions`,
  queryRegionByBusinessline: `${apiPrefix}/get_region_by_businessline`,
  commonGetPartners: `${apiPrefix}/query/partners`,
  querySupplierByBusinessLine: `${apiPrefix}/staff/querySupplierByBusinessLine`,
  getWorkTypeList: `${apiPrefix}/getWorkTypeList`,
  getBatteryRiskType: `${apiPrefix}/get_battery_risk_type_v2`,
  getSpockRiskType: `${apiPrefix}/get_all_risk_type`,
  getBikeType: `${apiPrefix}/find_by_bike_type_category`,

  // 首页 Dashboard
  getGenericData: `${apiPrefix}/query_generic_data`,
  getUserUnreadMessageList: `${apiPrefix}/v2/PushAppMsgIFace/queryPopupMsgList`, // 用户最近3条未读消息
  readMessage: `${apiPrefix}/message/push/template/user/message/read`, // 消息已读
  receiptMessage: `${apiPrefix}/message/push/template/user/message/receipt`, // 消息曝光/我已知晓

  // 员工管理：列表
  queryByPhone: `${apiPrefix}/staff/queryByPhone`,
  staffQueryStaffList: `${apiPrefix}/staff/queryStaffInfoList`,
  staffGetAccountStatus: `${apiPrefix}/get_user_account_state`,
  staffOpenUserAccount: `${apiPrefix}/staff/openUserAccount`,
  staffQueryStaffById: `${apiPrefix}/staff/queryStaffById`,
  staffReOpenAccount: `${apiPrefix}/staff/reOpenAccount`,
  staffOperateLogList: `${apiPrefix}/staff/staffOperateLogList`,
  staffGetStaffDetail: `${apiPrefix}/staff/getStaffDetail`,
  staffQuitStaff: `${apiPrefix}/staff/quitStaff`,
  staffAccountStopUse: `${apiPrefix}/staff/accountStopUse`,
  staffAccountRecover: `${apiPrefix}/staff/accountRecover`,
  staffGetAuthorityList: `${apiPrefix}/staff/getAuthorityListForSupplier`,
  staffEditAuthority: `${apiPrefix}/staff/editAuthority`,
  getStoreListByRegion: `${apiPrefix}/staff/getStoreListByRegion`,
  ifShowMolaAppTabAndStore: `${apiPrefix}/staff/ifShowMolaAppTabAndStore`,
  getBigCarrierListByRegion: `${apiPrefix}/carrier/get/carrierBigConfig/list`, // 根据region获取载具大类
  getSmallCarrierList: `${apiPrefix}/queryListByBigName`, // 获取载具小类
  getBindingCarrier: `${apiPrefix}/queryPartnerStaffCarrier`, // 获取绑定载具
  getOperatorAccountOwner: `${apiPrefix}/staff/getOperatorAccountOwner`, // 获取账号负责人

  // 员工管理：考勤明细
  queryClockInRecordList: `${apiPrefix}/workermanage/clock/queryClockInStatusOfDays`,
  exportClockinRecordList: `${apiPrefix}/workermanage/clock/exportClockInfo`,
  queryClockInDetailByDate: `${apiPrefix}/workermanage/clock/queryShiftClockInStream`,
  decodeByPersonId: `${apiPrefix}/workermanage/staff/getMobileByEmpId`,

  // 运营管理：地理围栏
  geofenceFenceMenu: `${apiPrefix}/query/fenceMenu/list`,
  geofenceFenceList: `${apiPrefix}/query/geofence/list`,
  geofenceFenceDelete: `${apiPrefix}/gis/geofence/delete`,
  geofenceFenceAdd: `${apiPrefix}/gis/geofence/add`,
  geofenceFenceUpdate: `${apiPrefix}/genfence/modify`,
  geofenceFencePreCheck: `${apiPrefix}/createGeoFence/preCheck`,

  // 数据看板：城市运营数据
  partnerDataList: `${apiPrefix}/partner/getSpockOperationReport`,

  // 数据看板：结费数据
  settlementList: `${apiPrefix}/settlement/agent/supplier/get/list`,
  settlementDetailExport: `${apiPrefix}/settlement/agent/supplier/get/detail/excel/v2`,
  getSpockDailyReport: `${apiPrefix}/b/apollo/getSpockDailyReport`,
  getRecommendInData: `${apiPrefix}/b/apollo/getDispatchPointInRecommend`,
  getDispatchDaily: `${apiPrefix}/b/apollo/getDispatchDailyReport`,
  getDispatchPonitLevel: `${apiPrefix}/b/apollo/getDispatchPointGrade`,
  getDispatchPonitOut: `${apiPrefix}/b/apollo/getDispatchPointOutRecommend`,
  getDispatchProfit: `${apiPrefix}/b/apollo/getDispatchIncomeAnalyse`,
  getBatteryDailyReport: `${apiPrefix}/get_power_exchange_all`,
  getBatteryDetailReport: `${apiPrefix}/get_power_exchange_detail`,
  getBatteryAnalysisReport: `${apiPrefix}/get_power_exchange_split_bytime`,
  getCommonDataList: `${apiPrefix}/query_generic_apollo_data`,
  dailydownload: `${apiPrefix}/settlement/agent/supplier/dailydownload`,
  flowdownload: `${apiPrefix}/settlement/agent/supplier/flowdownload`,

  // 数据导出
  exportSpockDailyReport: `${apiPrefix}/b/apollo/export/spockDailyReportToB`,
  exportRecommendInData: `${apiPrefix}/b/apollo/export/dispatchPointInRecommendToB`,
  exportDispatchDaily: `${apiPrefix}/b/apollo/export/dispatchDailyReportToB`,
  exportDispatchPonitLevel: `${apiPrefix}/b/apollo/export/dispatchPointGradeToB`,
  exportDispatchPonitOut: `${apiPrefix}/b/apollo/export/dispatchPointOutRecommendToB`,
  exportDispatchProfit: `${apiPrefix}/b/apollo/export/dispatchIncomeAnalyseToB`,
  exportBatteryDaily: `${apiPrefix}/export_power_exchange_all_report`,
  exportBatteryDetail: `${apiPrefix}/export_power_exchange_detail_report`,
  commonDataListExport: `${apiPrefix}/generic_export_data`,
  exportReportData: `${apiPrefix}/generic_export_v2`,

  // 绩效考核：考核方案
  peformancePlans: `${apiPrefix}/cooperate/peformance/region/list`,
  exportPeformancePlans: `${apiPrefix}/cooperate/export_region_performance_by_params`,

  // 绩效考核：绩效明细
  performanceList: `${apiPrefix}/cooperate/query_performance_by_params`,
  exportPerformanceList: `${apiPrefix}/cooperate/export_performance_by_params`,

  // 绩效考核：绩效目标
  getKpiTodo: `${apiPrefix}/RemoteKpiRuleConfigService/querySubmissionFormDetailList`,

  // 账单列表：日薪资明细
  dayGetStaffSettlementRecord: `${apiPrefix}/getStaffSettlementRecord`,
  getStaffSettlementRecordByTime: `${apiPrefix}/getStaffSettlementTimeRecord.do`,
  dayGetStaffRecordDetail: `${apiPrefix}/query/staff/settlement/detail`,
  dayExportStaffRecord: `${apiPrefix}/export/staffrecordbys3`,
  getBikeTaskTypeList: `${apiPrefix}/bizcode/list`,
  getActionTypeList: `${apiBasic}/action/list`,

  // 账单列表：月账单确认
  hrisStatisExport: `${apiPrefix}/export/hris/statis/data/v2`,
  exportOrderDataDetail: `${apiPrefix}/automation/supplierSalary/partner/data/detail/export`,
  exportOrderDataList: `${apiPrefix}/supplierCenter/data/list/export`,
  // 导出 新老接口开关
  exportSwitch: `${apiPrefix}/automation/salary/partner/query/switch`,
  exportPersonDataList: `${apiPrefix}/supplierCenter/person/list/export`,
  supplierOrderProcessStatus: `${apiPrefix}/supplierCenter/order/orderStatus`,
  generateCostOrder: `${apiPrefix}/supplierCenter/order/create`,
  importDistrubteFile: `${apiPrefix}/supplierCenter/person/separateImport`,
  savePersonPrice: `${apiPrefix}/supplierCenter/person/separate`,
  getDetailPersonList: `${apiPrefix}/supplierCenter/person/list`,
  savePriceBatch: `${apiPrefix}/supplierCenter/person/separateBatch`,
  changeOrderStatus: `${apiPrefix}/supplierCenter/order/auditByOrderId`,
  getSupplierCostList: `${apiPrefix}/supplierCenter/data/list`,
  settlementMultiInvoicesRecoding: `${apiPrefix}/settlement/invoice/multiInvoicesRecoding`,
  settlementInvoiceListPayOrders: `${apiPrefix}/settlement/invoice/listPayOrders`,
  settlementInvoiceListInvoices: `${apiPrefix}/settlement/invoice/listInvoicesByOrderId`,
  settlementDownloadPayOrder: `${apiPrefix}/settlement/data/billPrint`,
  settlementDownloadInvoice: `${apiPrefix}/invoice/downloadInvoice`,
  settlementInvoiceSubmit: `${apiPrefix}/settlement/invoice/submit`,
  // 发票提效
  settlementGetPayOrdersHella: `${apiPrefix}/invoice/getPayOrders`,
  settlementGetInvoiceHella: `${apiPrefix}/invoice/getInvoice`,

  // 对账单确认
  getBillConfirmData: `${apiPrefix}/agent/settlementOrder/supplier/query/pageList`,
  exportBillConfirm: `${apiPrefix}/agent/settlementOrder/supplier/export/data`,
  saveBillConfirm: `${apiPrefix}/agent/settlementOrder/supplier/confirm`,
  getOrderDetailFee: `${apiPrefix}/agent/settlementOrder/supplier/query/data/orderDetail`,

  // 服务中心
  getServiceTodo: `${apiPrefix}/evaluation/instance/pend`,
}

export { api, getMixWaterMarkImage, getWaterMarkImage }
